export default "__VITE_ASSET__B2cAjY$D__"